<form
  #confirmReject="ngForm"
  (ngSubmit)="onClose(true)"
  fxLayout="column"
  class="with-padding-large dialog-container"
  fxLayoutGap="8px"
  fxFlex
>
  <mat-label mat-dialog-title translate>
    {{ confirm.title | translate }}
  </mat-label>
  <mat-divider></mat-divider>

  <mat-dialog-content fxFlex
    >{{ confirm.message | translate }}
    <span *ngIf="confirm.isRequired">*</span>
    <br />
    <br />
    <textarea
      class="textarea-dialog"
      type="text"
      placeholder="Comment"
      [(ngModel)]="text_area"
      name="text_area"
      [required]="confirm.isRequired"
    ></textarea>
  </mat-dialog-content>

  <div
    class="kmt-toolbar with-horizontal-padding"
    fxLayout="row"
    fxLayoutGap="8px"
    fxLayoutAlign="start center"
  >
    <div class="spacer" fxFlex></div>
    <button type="button" mat-stroked-button (click)="onClose(false)">
      {{ confirm.cancelText | translate }}
    </button>
    <button
      type="button"
      mat-flat-button
      color="primary"
      (click)="onClose(true)"
      [disabled]="!confirmReject.valid"
    >
      {{ confirm.okText | translate }}
    </button>
  </div>
</form>
